(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-how-made"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.ps-home-how-made__arrow');
    if (arrow) {
      const section = arrow.closest('.ps-home-how-made');
      const items = [...section.querySelectorAll('.ps-home-how-made__item')];
      const tabs = [...section.querySelectorAll('.ps-home-how-made__tab')];
      const currentIndex = items.findIndex((item) => item.open);
      const direction = Number(arrow.dataset.howMadeDirection);
      const selectedIndex = (currentIndex + direction + items.length) % items.length;

      items.forEach((item, index) => {
        item.open = index === selectedIndex;
      });
      tabs.forEach((candidate, index) => {
        const selected = index === selectedIndex;
        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });
      return;
    }

    const tab = event.target.closest('.ps-home-how-made__tab');
    if (tab) {
      const section = tab.closest('.ps-home-how-made');
      const selectedIndex = Number(tab.dataset.howMadeIndex);
      const items = [...section.querySelectorAll('.ps-home-how-made__item')];
      const tabs = [...section.querySelectorAll('.ps-home-how-made__tab')];

      items.forEach((item, index) => {
        item.open = index === selectedIndex;
      });
      tabs.forEach((candidate, index) => {
        const selected = index === selectedIndex;
        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });
      return;
    }

    const summary = event.target.closest('.ps-home-how-made__summary');
    if (!summary) return;

    const item = summary.closest('.ps-home-how-made__item');
    if (item?.open) event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();
})();
